<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="immigration_benefit of peParty.immigration_benefits"
      :key="immigration_benefit.id"
      class="mb-12"
    >
      <ImmigrationBenefitsCard
        :item="immigration_benefit"
      />
    </div>

    <SectionAdderLine
      section="Immigration Benefit"
      :has-new-section="peImmigrationBenefitsCardHasNewSection"
      @on-add="peImmigrationBenefitsCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import ImmigrationBenefitsCard from '@/components/Party/PartyEdit/SectionCards/BackgroundCards/ImmigrationBenefitsCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'ImmigrationBenefitsStep',

  components: {
    GenericStep,
    ImmigrationBenefitsCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.immigration_benefits
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peImmigrationBenefitsCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peImmigrationBenefitsCardAddSection',
    ]),
  },
}
</script>
